// extracted by mini-css-extract-plugin
module.exports = {"container":"e_l2","card":"e_m2","wideContainer":"e_n2","containerHollow":"e_o2"};